import React from 'react';
import { Box } from '@mui/material';

/**
 * Horizontal scrollable row of category pills, like the "All Items / Starters /
 * Mains / Pizzas" row in the mockup. Spacing uses logical properties so the
 * order naturally reverses under RTL.
 */
const CategoryPills = ({ items, value, onChange }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        gap: 1,
        overflowX: 'auto',
        py: 1,
        // Hide the scrollbar — the row already gives a scroll hint via partial pills at the edge.
        scrollbarWidth: 'none',
        '&::-webkit-scrollbar': { display: 'none' },
      }}
      role="tablist"
    >
      {items.map((item) => {
        const active = item.id === value;
        return (
          <Box
            key={item.id}
            component="button"
            type="button"
            role="tab"
            aria-selected={active}
            onClick={() => onChange?.(item.id)}
            sx={{
              flexShrink: 0,
              display: 'inline-flex',
              alignItems: 'center',
              gap: 1,
              border: '1px solid',
              borderColor: active ? 'primary.main' : 'divider',
              backgroundColor: active ? 'primary.main' : 'background.paper',
              color: active ? 'primary.contrastText' : 'text.primary',
              borderRadius: 9999,
              paddingInline: 2,
              paddingBlock: 1,
              fontSize: 14,
              fontWeight: active ? 600 : 500,
              cursor: 'pointer',
              transition: 'background-color 120ms ease, color 120ms ease, border-color 120ms ease',
              '&:hover': {
                backgroundColor: active ? 'primary.main' : 'action.hover',
              },
            }}
          >
            <span>{item.label}</span>
            {typeof item.count === 'number' && (
              <Box
                component="span"
                sx={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  minWidth: 22,
                  height: 20,
                  paddingInline: 0.75,
                  borderRadius: 9999,
                  fontSize: 12,
                  fontWeight: 600,
                  backgroundColor: active ? 'rgba(255,255,255,0.18)' : 'action.selected',
                  color: active ? '#fff' : 'text.secondary',
                }}
              >
                {item.count}
              </Box>
            )}
          </Box>
        );
      })}
    </Box>
  );
};

export default CategoryPills;
